module.exports = __webpack_public_path__ + "img/bg_banner.43899054.png";